import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";

import MockupShell from "./_lib/MockupShell";
import MOCKUP_REGISTRY from "./hillRegistry";

const MockupsRoot = () => {
  const { hillKey } = useParams();
  const [state, setState] = useState({ status: "loading", hill: null, error: null });

  useEffect(() => {
    if (!hillKey) {
      return;
    }
    const loader = MOCKUP_REGISTRY[hillKey];
    if (!loader) {
      setState({ status: "missing", hill: null, error: null });
      return;
    }
    loader()
      .then((mod) => {
        const hill = mod.default || mod;
        setState({ status: "ready", hill, error: null });
      })
      .catch((err) => {
        setState({ status: "error", hill: null, error: err.message });
      });
  }, [hillKey]);

  if (state.status === "loading") {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh" }}>
        <CircularProgress />
      </Box>
    );
  }

  if (state.status === "missing") {
    return (
      <Box sx={{ p: 4 }}>
        <Typography variant="h6">No mockup registered for "{hillKey}".</Typography>
        <Typography variant="body2" color="textSecondary">
          Run the /generate-ui-mockup skill to create one.
        </Typography>
      </Box>
    );
  }

  if (state.status === "error") {
    return (
      <Box sx={{ p: 4 }}>
        <Typography variant="h6">Failed to load mockup.</Typography>
        <Typography variant="body2" color="error">
          {state.error}
        </Typography>
      </Box>
    );
  }

  return <MockupShell hill={state.hill} />;
};

export default MockupsRoot;
